export const COLOR_CLASSES = {
    chocobo: {
      yellow: {
        light: 'bg-yellow-500',
        dark: 'dark:bg-yellow-600'
      },
      pink: {
        light: 'bg-pink-500',
        dark: 'dark:bg-pink-600'
      },
      black: {
        light: 'bg-gray-900',
        dark: 'dark:bg-black'
      },
      gold: {
        light: 'bg-yellow-600',
        dark: 'dark:bg-yellow-500'
      },
      blue: {
        light: 'bg-blue-500',
        dark: 'dark:bg-blue-600'
      },
      green: {
        light: 'bg-green-500',
        dark: 'dark:bg-green-600'
      },
      white: {
        light: 'bg-gray-400',
        dark: 'dark:bg-gray-500'
      },
      red: {
        light: 'bg-red-500',
        dark: 'dark:bg-red-600'
      }
    },
    statGrades: {
      'S+': {
        light: 'bg-purple-200 text-purple-900',
        dark: 'dark:bg-purple-900 dark:text-purple-100'
      },
      'S': {
        light: 'bg-purple-100 text-purple-800',
        dark: 'dark:bg-purple-800 dark:text-purple-200'
      },
      'S-': {
        light: 'bg-purple-50 text-purple-700',
        dark: 'dark:bg-purple-700 dark:text-purple-300'
      },
      'A+': {
        light: 'bg-blue-200 text-blue-900',
        dark: 'dark:bg-blue-900 dark:text-blue-100'
      },
      'A': {
        light: 'bg-blue-100 text-blue-800',
        dark: 'dark:bg-blue-800 dark:text-blue-200'
      },
      'A-': {
        light: 'bg-blue-50 text-blue-700',
        dark: 'dark:bg-blue-700 dark:text-blue-300'
      },
      'B+': {
        light: 'bg-green-200 text-green-900',
        dark: 'dark:bg-green-900 dark:text-green-100'
      },
      'B': {
        light: 'bg-green-100 text-green-800',
        dark: 'dark:bg-green-800 dark:text-green-200'
      },
      'B-': {
        light: 'bg-green-50 text-green-700',
        dark: 'dark:bg-green-700 dark:text-green-300'
      },
      'C+': {
        light: 'bg-yellow-200 text-yellow-900',
        dark: 'dark:bg-yellow-900 dark:text-yellow-100'
      },
      'C': {
        light: 'bg-yellow-100 text-yellow-800',
        dark: 'dark:bg-yellow-800 dark:text-yellow-200'
      },
      'C-': {
        light: 'bg-yellow-50 text-yellow-700',
        dark: 'dark:bg-yellow-700 dark:text-yellow-300'
      },
      'D+': {
        light: 'bg-orange-200 text-orange-900',
        dark: 'dark:bg-orange-900 dark:text-orange-100'
      },
      'D': {
        light: 'bg-orange-100 text-orange-800',
        dark: 'dark:bg-orange-800 dark:text-orange-200'
      },
      'D-': {
        light: 'bg-orange-50 text-orange-700',
        dark: 'dark:bg-orange-700 dark:text-orange-300'
      },
      'E': {
        light: 'bg-red-100 text-red-800',
        dark: 'dark:bg-red-800 dark:text-red-200'
      },
      'F': {
        light: 'bg-red-50 text-red-700',
        dark: 'dark:bg-red-700 dark:text-red-300'
      }
    },  
    behavior: {
      1: { // Disciplined
        light: 'bg-green-100 text-green-800',
        dark: 'dark:bg-green-900 dark:text-green-100'
      },
      2: { // Spirited
        light: 'bg-blue-100 text-blue-800',
        dark: 'dark:bg-blue-900 dark:text-blue-100'
      },
      3: { // Steady
        light: 'bg-gray-100 text-gray-800',
        dark: 'dark:bg-gray-800 dark:text-gray-100'
      },
      4: { // Cautious
        light: 'bg-yellow-100 text-yellow-800',
        dark: 'dark:bg-yellow-900 dark:text-yellow-100'
      },
      5: { // Stubborn
        light: 'bg-orange-100 text-orange-800',
        dark: 'dark:bg-orange-900 dark:text-orange-100'
      },
      6: { // Skittish
        light: 'bg-purple-100 text-purple-800',
        dark: 'dark:bg-purple-900 dark:text-purple-100'
      },
      7: { // Rebellious
        light: 'bg-red-100 text-red-800',
        dark: 'dark:bg-red-900 dark:text-red-100'
      },
      8: { // Feral
        light: 'bg-red-200 text-red-900',
        dark: 'dark:bg-red-950 dark:text-red-100'
      }
    },
    training: {
      speed: {
        light: 'bg-blue-100 text-blue-800',
        dark: 'dark:bg-blue-900 dark:text-blue-100'
      },
      stamina: {
        light: 'bg-green-100 text-green-800',
        dark: 'dark:bg-green-900 dark:text-green-100'
      },
      behavior: {
        light: 'bg-purple-100 text-purple-800',
        dark: 'dark:bg-purple-900 dark:text-purple-100'
      }
    },
    gender: {
      male: {
        light: 'text-blue-500',
        dark: 'dark:text-blue-400'
      },
      female: {
        light: 'text-pink-500',
        dark: 'dark:text-pink-400'
      }
    },
    wealth: {
      scraping: {
        light: 'bg-red-100 text-red-800',
        dark: 'dark:bg-red-900 dark:text-red-100'
      },
      making_do: {
        light: 'bg-orange-100 text-orange-800',
        dark: 'dark:bg-orange-900 dark:text-orange-100'
      },
      living_well: {
        light: 'bg-yellow-100 text-yellow-800',
        dark: 'dark:bg-yellow-900 dark:text-yellow-100'
      },
      well_off: {
        light: 'bg-green-100 text-green-800',
        dark: 'dark:bg-green-900 dark:text-green-100'
      },
      wealthy: {
        light: 'bg-blue-100 text-blue-800', 
        dark: 'dark:bg-blue-900 dark:text-blue-100'
      },
      mogul: {
        light: 'bg-purple-100 text-purple-800',
        dark: 'dark:bg-purple-900 dark:text-purple-100'
      }
    }
  };
  
  export const getChocoboColorClass = (color) => {
    const classes = COLOR_CLASSES.chocobo[color] || COLOR_CLASSES.chocobo.yellow;
    return `${classes.light} ${classes.dark}`;
  };

  export const getStatGradeClass = (grade) => {
    const classes = COLOR_CLASSES.statGrades[grade] || COLOR_CLASSES.statGrades['F'];
    return `${classes.light} ${classes.dark}`;
  };
  
  export const getBehaviorClass = (behaviorId) => {
    const classes = COLOR_CLASSES.behavior[behaviorId] || COLOR_CLASSES.behavior[3];
    return `${classes.light} ${classes.dark}`;
  };
  
  export const getTrainingClass = (trainingType) => {
    const classes = COLOR_CLASSES.training[trainingType] || COLOR_CLASSES.training.speed;
    return `${classes.light} ${classes.dark}`;
  };
  
  export const getGenderClass = (gender) => {
    const classes = COLOR_CLASSES.gender[gender] || COLOR_CLASSES.gender.male;
    return `${classes.light} ${classes.dark}`;
  };
  
  export const getWealthClass = (money) => {
    let tier;
    if (money < 15000) tier = 'scraping';
    else if (money < 30000) tier = 'making_do';
    else if (money < 50000) tier = 'living_well';
    else if (money < 75000) tier = 'well_off';
    else if (money < 100000) tier = 'wealthy';
    else tier = 'mogul';
  
    const classes = COLOR_CLASSES.wealth[tier];
    return `${classes.light} ${classes.dark}`;
  };
  
  
  
  